var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2074 17.8351C19.6594 16.5111 18.0884 15.7091 16.5594 17.0311L15.6464 17.8301C14.9784 18.4101 13.7364 21.1201 8.93443 15.5961C4.13343 10.0791 6.99043 9.22015 7.65943 8.64515L8.57743 7.84515C10.0984 6.52015 9.52443 4.85215 8.42743 3.13515L7.76543 2.09515C6.66343 0.382145 5.46343 -0.742854 3.93843 0.580145L3.11443 1.30015C2.44043 1.79115 0.556428 3.38715 0.0994285 6.41915C-0.450572 10.0571 1.28443 14.2231 5.25943 18.7941C9.22943 23.3671 13.1164 25.6641 16.7984 25.6241C19.8584 25.5911 21.7064 23.9491 22.2844 23.3521L23.1114 22.6311C24.6324 21.3091 23.6874 19.9631 22.1384 18.6361L21.2074 17.8351Z",
    fill: "#192D59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c25a3a6c7485c3955255f07a4cd64bb1.svg";
export { ForwardRef as ReactComponent };